import clueTouchChannel from './clueTouchChannel'
export default clueTouchChannel
